import type { z } from 'zod';

import { industryQuerySchema } from './industry-query-schema';

export const industryQueryLinkerSchema = industryQuerySchema.pick({
  id: true,
  name: true,
  parent: true,
});

export type IndustryQueryLinkerSchema = z.infer<typeof industryQueryLinkerSchema>;
